/**
 * Margin, Cost & Cash — the analytics surface (page shell only, CD-7). The page declares
 * its own scope (19 Aug 2026): entity and period, and NO grain. Sage keeps months, so a
 * weekly setting here asked the finance master for rows it does not hold and the surface
 * refused with "No finance cells served" — an axis that could only ever be wrong. Scope
 * still lives in the URL, so a deep link reproduces the exact view. The fetch, the P&L bridge,
 * the Sage → ERP month test and the Group→Entity reconciliation live in MarginBody. Every £ is a served Sage cell in its trust envelope —
 * no representative view-model. The order-book half DOES carry cost (FM part standards +
 * works-order job-cost actuals, joined at serve time; RA null pending the Red Ant gap), and margin
 * is computed on the COSTED portion only with coverage published — never a fabricated 100%.
 */

import React from 'react'
import ScopeBar from '../components/kit/ScopeBar'
import { entityAxis, periodAxis } from '../components/kit/scopeAxes'
import { useScope } from '../hooks/useScope'
import MarginBody from './MarginBody'

export default function Margin(): React.JSX.Element {
  const scope = useScope()
  return (
    <div className="cx-fade cx-page py-6 pb-20 space-y-4">
      <header>
        <div className="font-mono text-[10px] tracking-[.16em] uppercase mb-1.5" style={{ color: 'var(--green)' }}>
          Margin, Cost &amp; Cash · Sage ledger
        </div>
        <h1 className="text-[26px] font-bold tracking-[-.02em] text-ink">Margin</h1>
        <p className="mt-1.5 text-[13.5px] text-mut">
          The Sage P&amp;L bridge, and the test that our invoices agree with it — month by month,
          and at Group entity by entity.
        </p>
      </header>
      <ScopeBar axes={[entityAxis(scope), periodAxis()]} />
      <MarginBody scope={scope} />
    </div>
  )
}
